import { Component, OnInit } from "@angular/core";
import { CueWidgetService } from "services/cue-widget.service";

@Component({
	selector: "ras-whatsapp-test-page",
	templateUrl: "./whatsapp-test-page.component.html",
	styleUrls: ["./whatsapp-test-page.component.sass"]
})
export class WhatsappTestPageComponent implements OnInit {

	widgetReady = false;
	testDataSent = false;

	constructor(private cueWidget: CueWidgetService) { }

	ngOnInit() {
		// Check if widget is ready
		setTimeout(() => {
			this.widgetReady = this.cueWidget.isWidgetReady();
		}, 2000);

		// Send test data
		this.cueWidget.updateSessionData({
			testPage: "whatsapptest",
			timestamp: new Date().toISOString(),
			source: "website"
		});
	}

	sendTestData() {
		const result = this.cueWidget.updateSessionData({
			manualTest: true,
			clickedAt: new Date().toISOString(),
			userAction: "button_click"
		});
		this.testDataSent = result;
		alert(result ? "Test data sent successfully!" : "Widget not ready yet. Data queued.");
	}
}
